import { v4 as uuidV4 } from 'uuid';

export const randomId = () => Math.random().toString().substring(2, 12);

export const randomUUID = () => uuidV4();
